import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface CountdownProps {
  initialMinutes?: number;
  initialSeconds?: number;
  handleResendOtp: () => void;
  onTimerExpire?: () => void; // New callback for when timer expires
}
const CountdownWithResend = (props: CountdownProps) => {

    const { initialMinutes = 0, initialSeconds = 10, handleResendOtp, onTimerExpire } = props;
    const [minutes, setMinutes] = useState(initialMinutes);
    const [seconds, setSeconds] = useState(initialSeconds);
    const [resendEnabled, setResendEnabled] = useState(false);

    useEffect(() => {
        let timer = setInterval(() => {
            if (seconds > 0) {
                setSeconds((prev:any) => prev - 1);
            } else {
                if (minutes > 0) {
                    setMinutes((prev:any) => prev - 1);
                    setSeconds(59);
                } else {
                    clearInterval(timer);
                    setResendEnabled(true); // ✅ Enable resend when time hits 00:00
                    
                    // Call the onTimerExpire callback if provided
                    if (onTimerExpire) {
                        onTimerExpire();
                    }
                }
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [minutes, seconds]);

    const formatTime = (num: any) => num.toString().padStart(2, '0');

    const handleResend = (e: any) => {
        e.preventDefault();
        if (!resendEnabled) return;

        // ✅ Implement your resend logic here
        console.log("Resend OTP triggered");

        // Reset timer and disable resend
        setMinutes(initialMinutes);
        setSeconds(initialSeconds);
        setResendEnabled(false);
        handleResendOtp();
    };

    return (
        <div>
            <div className="badge bg-danger-transparent mb-3">
                <p className="d-flex align-items-center">
                    <i className="ti ti-clock me-1" />
                    {formatTime(minutes)}:{formatTime(seconds)}
                </p>
            </div>

            <div className="mb-3 d-flex justify-content-center">
                <p className="text-black">
                    Didn't get the OTP?{" "}
                    <Link
                        to="#"
                        onClick={handleResend}
                        className={`text-white ${!resendEnabled ? 'disabled-link' : ''}`}
                        style={{
                            pointerEvents: resendEnabled ? 'auto' : 'none',
                            opacity: resendEnabled ? 1 : 0.5,
                            textDecoration: resendEnabled ? 'underline' : 'none'
                        }}
                    >
                        Resend OTP
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default CountdownWithResend;
